<template>
  <div class="wrapper" v-loading="isLoading">
    <header>
      <a-form-model
        layout="inline"
        :label-col="{ span: 7 }"
        :wrapper-col="{ span: 17 }"
      >
        <a-form-model-item :label="$t('maintain.startTime')">
          <a-date-picker v-model="warningHistoryStartTime" style="margin: 0 20px;" />
        </a-form-model-item>
        <a-form-model-item :label="$t('maintain.endTime')">
          <a-date-picker v-model="warningHistoryEndTime" />
        </a-form-model-item>
      </a-form-model>
      <a-button type="primary" @click="renderWarningHistoryList">{{ $t("buttons.search") }}</a-button>
    </header>
    <a-empty style="height: 100%;" v-if="warnings.length === 0" />
    <div class="cardsGroup" v-else>
      <el-card v-for="w in warnings" :key="w.id">
        <div slot="header" class="clearfix">
          <h3>
            {{ warningTypesMap[w.warningType][lang] }}
          </h3>
        </div>
        <p>{{ $t("SIM.company") + ": " + w.customerName }}</p>
        <p>{{ $t("binding.serviceMan") + ": " + w.serviceNames }}</p>
        <p>{{ $t("warning.createdAt") + ": " + w.createdAt }}</p>
      </el-card>
    </div>
  </div>
</template>

<script>
import { getWarningHistory } from "@/api/warning"
import { getMenusOfCurrentUser } from "@/api/auth/menu"
import { searchDeviceList } from "@/api/device"

import moment from "moment"

export default {
  props: {
    device: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      isLoading: false,
      warnings: [],
      warningTypesMap: {},
      warningHistoryStartTime: null,
      warningHistoryEndTime: null
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    device() {
      this.render()
    }
  },
  mounted() {
    this.render()
  },
  methods: {
    async render() {
      const date = new Date()
      this.warningHistoryEndTime = moment(+new Date(date))
      date.setMonth(date.getMonth() - 1)
      this.warningHistoryStartTime = moment(+new Date(date))
      this.renderWarningHistoryList()

      const data = await this.requestWarningMenus()
      const warningTypesMap = {}
      let w
      for (let i = 0; i < data.length; i++) {
        w = data[i];
        (w.details || []).forEach(d => {
          w[d.locale] = d.name
        })
        w.name = w["zh-CN"]
        warningTypesMap[w.routeName] = {
          zh: w["zh-CN"],
          en: w["en-US"]
        }
      }
      this.warningTypesMap = warningTypesMap
    },
    async renderWarningHistoryList() {
      if (!this.warningHistoryStartTime || !this.warningHistoryEndTime) {
        return this.$message.warning(this.$t("placeholder.timeRange"))
      }
      
      this.isLoading = true

      const data = await this.requestWarningHistories()
      const device = await this.requestDevice(this.device.id)
      let warnings = []
      if (device) {
        let customerName = device.customer.company
        let serviceNamesMap = {}, serviceNames = ""
        if (device.customer.serviceMans?.length) {
          device.customer.serviceMans.forEach(s => {
            serviceNamesMap[s.username] = s.realName
          })
          serviceNames = Object.values(serviceNamesMap).join(", ")
        }

        let d
        for (let key in data) {
          d = data[key]
          if (d.length) {
            warnings = warnings.concat(d.map(dd => {
              dd.warningType = key
              dd.customerName = customerName
              dd.serviceNames = serviceNames
              if (dd.createdAt) {
                dd.createdAt = moment(+dd.createdAt).format("YYYY-MM-DD HH:mm:ss")
              }
              return dd
            }))
          }
        }
      }
      this.warnings = warnings
      this.isLoading = false
    },
    goToWarning(w) {
      localStorage.setItem("deviceCode", w.device.code)
      localStorage.setItem("targetWarningType", warningTypeMap[w.warningType].code)
      if (this.showDetailMethod) {
        this.showDetailMethod(warningTypeMap[w.warningType].code)
        return
      }
      let routeUrl = this.$router.resolve({
        path: "/warning"
      })
      window.open(routeUrl.href, "_blank")
    },
    async requestWarningHistories() {
      try {
        const { data } = await getWarningHistory({
          startTime: +this.warningHistoryStartTime._d,
          endTime: +this.warningHistoryEndTime._d,
          deviceCode: this.device.code
        })

        return data
      } catch(e) {
        console.log(e)
        return {}
      }
    },
    async requestWarningMenus() {
      try {
        const { data } = await getMenusOfCurrentUser()
        const menu = data.find(r => r.id === 40)

        return menu.children ?? []
      } catch (e) {
        console.log(e)
        return []
      }
    },
    async requestDevice(id) {
      try {
        const { data } = await searchDeviceList(1, 1, {
          query: [],
          filter: [
            {
              field: "id",
              value: id
            }
          ]
        })
        if (data.total && data.records[0]) {
          return data.records[0]
        }
        
        return null
      } catch(e) {
        console.log(e)

        return null
      }
    }
  }
}
</script>

<style lang="less" scoped>
header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  padding-right: 20px;
}
.wrapper {
  width: 100%;
  height: 100%;
  h3 {
    font-size: 18px;
    font-weight: normal;
    margin: 10px;
  }
  /deep/ .el-card {
    width: 23%;
    height: 53%;
    margin-bottom: 15px;
    .el-card__header {
      padding: 0;
    }
    &:nth-child(4n + 1) {
      margin-left: 1%;
    }
    &:nth-child(4n + 2),
    &:nth-child(4n + 3) {
      margin-left: 2%;
    }
    &:nth-child(4n + 3) {
      margin-right: 2%;
    }
  }
  .cardsGroup {
    width: 100%;
    height: calc(100% - 110px);
    margin-top: 6px;
    overflow: auto;
    display: flex;
    padding-top: 5px;
    flex-wrap: wrap;
    h3 {
      font-size: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}
/deep/ .ant-empty-image {
  height: 65%;
}
/deep/ .ant-form-item {
  margin: 0 !important;
}
</style>